<template>
  <div>
      <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>basic data</el-breadcrumb-item>
      <el-breadcrumb-item>My Engineer</el-breadcrumb-item>
    </el-breadcrumb>
 <!-- 卡片视图区域 -->
 <el-card>
  <!-- 搜索与添加区域 -->
    <collapse @getDataList="search" :button-text="'search'">
        <collapse-item>
        <span class="PlumberCompany" width="300px">Plumber Company:</span> 
            <el-input style="width=300px" placeholder="please enter pulmber company,contact number,name,email to search" v-model="queryInfoparams.params.keyword" clearable ></el-input>      
        </collapse-item>
   </collapse>
   <el-row type="flex" justify="end">
               <el-col class="searchBtns" :span="6">
                <el-button-group>
                 <el-button plain size="small" icon="el-icon-download" @click="exportData">Export</el-button>
                </el-button-group>
               </el-col>
   </el-row> 
   <el-table :data="dataList" border stripe>
   <el-table-column type="index" label="No."></el-table-column>
   <el-table-column label="Plumber company" sortable prop="companyName" width="180px"></el-table-column>
   <el-table-column label="email" sortable prop="email" width="180px"></el-table-column>
   <el-table-column label="First Name" sortable prop="firstName" width="180px"></el-table-column>
   <el-table-column label="Last Name" sortable prop="lastName" width="180px"></el-table-column>
   <el-table-column label="Phone number" sortable prop="mobileNumber" width="180px"></el-table-column>
   <el-table-column label="State" sortable prop="state" width="180px"></el-table-column>
   <el-table-column label="City" sortable prop="city" width="180px"></el-table-column>
   <el-table-column label="Suburb" sortable prop="suburb" width="180px"></el-table-column>
   <el-table-column label="Status" sortable prop="status" width="180px">
      <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='0'" >Enabled</el-tag>
            <el-tag v-else-if="scope.row.status==='1'" >Disabled</el-tag>
      </template>
   </el-table-column>
   <el-table-column label="Tests done last week" sortable prop="testingWeek" width="180px"></el-table-column>
   <el-table-column label="Tests done last month" sortable prop="testingMonth" width="180px"></el-table-column>
   <el-table-column label="operate" width="250px" fixed="right">
<!-- 按钮 -->
        <template slot-scope="scope">
           <div class="btnContainer">
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="showEditDialog(scope.row.id,scope.row.userId)" >edit</el-link> 
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="enableEngineer(scope.row.id,scope.row.userId)" >enable</el-link> 
             <el-link plain size="small"  icon="el-icon-edit-outline" @click="suspendEngineer(scope.row.id,scope.row.userId)" >suspend</el-link>
           </div>
        </template>
   </el-table-column>
  </el-table>
    <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
 </el-card> 
    <!-- 修改用户的对话框  此处可与添加用户 优化合并为一个对话框-->
    <el-dialog title="Edit Plumber" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="70px" >
        <el-row>
          <el-input id="displayInput" v-model="addForm.agencyId"></el-input>
          <el-col :span="12">

        <el-form-item class="left" label="Agent" prop="agencyName" label-width="140px">
          <el-input v-model="addForm.agencyName" disabled></el-input>
        </el-form-item>
          </el-col>
               <el-col :span="12">
               <el-form-item  label="Email-address" label-width="140px" prop="email">
          <el-input placeholder=" enter the email" v-model="addForm.email" disabled></el-input>
        </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item class="companyName"  label-position="left" label="Company Name" prop="companyName" label-width="140px">
                  <el-input v-model="addForm.companyName" disabled></el-input>
              </el-form-item>
             </el-col>
             <el-col :span="12">
                <el-form-item label="Contact number" prop="mobileNumber" label-width="140px">
                 <el-input placeholder=" enter the number" v-model="addForm.mobileNumber"></el-input>
                </el-form-item>
            </el-col>  
        </el-row>
        <el-row>
           <el-col :span="12">
                <el-form-item class="left" label="firstName" prop="firstName" label-width="140px">
                    <el-input placeholder=" enter the first name" v-model="addForm.firstName"></el-input>
                 </el-form-item>
            </el-col>
            <el-col :span="12">
             <el-form-item class="left" label="lastName" prop="lastName" label-width="140px">
                <el-input placeholder=" enter the surname" v-model="addForm.lastName"></el-input>
              </el-form-item>
            </el-col>
        </el-row>
       <el-row>
            <el-col :span="12">
             
                  <el-form-item label="Area" prop="areaList" label-width="160px">
                  <el-cascader
                  placeholder=" select area"
                  filterable
                  style="width:100%"
                  clearable
                  size="medium"
                  v-model="areaList"
                  :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
                  :options="areaTreeList"
                  ref="treeArea"
                  ></el-cascader>
                  </el-form-item>
                  </el-col> 
                   <el-col :span="12">
             
        <el-form-item label="Detail Address" prop="city" label-width="140px">
          <el-input v-model="addForm.address"></el-input>
        </el-form-item>
            </el-col>             
        </el-row>
       <el-row>
           <el-col :span="12">
        <el-form-item class="left" label="Post Code" prop="postCode" label-width="140px">
          <el-input v-model="addForm.postCode"></el-input>
        </el-form-item>
            </el-col>
                    
        </el-row>



      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="editEngineerInfo">Save</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Edit Plumber" :visible.sync="editEmailVisible" width="50%" @close="editDialogClosed">
        <el-row>
         <el-col :span="12">
               <el-form-item  label="Email-address" label-width="125px">
               <el-input v-model="addForm.email"></el-input>
               </el-form-item>
          </el-col>                   
        </el-row>
        <span slot="footer" class="dialog-footer">
        <el-button @click="editEmailVisible = false">Cancel</el-button>
        <el-button type="primary" >Save</el-button>
      </span>
     </el-dialog>
 </div>
</template>

<script>
import db from '@/services/localstorage';
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
export default {
    components:{Collapse,CollapseItem},
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: 'last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'last three month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        options: [
         {
          value: '',
          label: 'all'
        }, {
          value: '1',
          label: 'used'
        }, {
          value: '0',
          label: 'unused'
        }],
        addressOptions: [
          {
          value: '',
          label: ''
        }],
        userId:'',
        value: '',
        queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
        },
        addFormRules: {
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email' }
        ],
        firstName: [
          { required: true, message: 'First name is required', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Last name is required', trigger: 'blur' },
        ],
         mobileNumber: [
          { required: true, message: 'Contact Number is required', trigger: 'blur' },
        ],
         postCode: [
          { required: true, message: 'Post Code is required', trigger: 'blur' },
        ],
         areaList: [
          { required: true, message: 'Area is required', trigger: 'blur' },
        ],
        },
        dataList: [],
        addForm: {
        agencyName:'',
        email:'',
        companyName:'',
        loginAccount: '',
        firstName:'',
        mobileNumber:'',
        lastName:'',
        postCode:'',
        address:'',
        userId:'',
        source:'',
        companyId:'',
        areaList:'',
        areaFullpath: '',
        },
        userId:'',
        companyId:'',
        areaList:'',
        // 添加表单的验证规则对象
        addFormRules: {},
        total: 0,
        // 控制添加 对话框的显示与隐藏
        addDialogVisible: false,
        // 控制修改用户对话框的显示与隐藏
        editDialogVisible: false,
        addFormRules: {},
        editEmailVisible: false,
      }
      
    },

    created(){
      var user=db.get("user");
      this.userId=user.userId;
      this.addForm.userType=user.userType;
      this.companyId=user.companyId;
      this.queryInfoparams.params.userType=user.userType;
      this.queryInfoparams.params.agencyUserId=user.companyId;
      this.userId=user.userId;
      this.search();
      //console.log("companyId:"+this.addForm.companyId);
    //  console.log("userId:"+this.addForm.userId);
    },
    methods: {

       //获取区域地址信息
    getAreaTreeList(){
        this.$get(`tree/getTreeByCode/TREE_PROVINCE/Y/false`).then(({ data: res }) => {
          
            this.areaTreeList = res.data
        })
    },

    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
        // 获取 查询数据列表
    async getDataList() {      
      this.$post('engineer/pageQuery', this.queryInfoparams).then(
          ({ data: res }) => {
            this.dataList = res.records
            this.total = res.total
          }
        )
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.addDialogVisible=false
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮 添加
    async exportData() {
       console.log("queryInfoparams:"+this.queryInfoparams.params.userType)
     // addForm.userId=db.get("userId")
     let res = this.$export("engineer/export",JSON.stringify(this.queryInfoparams),"plumber_information")
    },
    
    editDialogClosed() {
      this.editDialogVisible=false
      this.$refs.editFormRef.resetFields()
    },
    // 展示编辑用户的对话框
    async showEditDialog(id,userId) {
      console.log("id"+id);
      this.editDialogVisible = true
      this.$get(`engineer/queryEngineerById/${id}`).then(({ data: res }) => {
        console.log(res)
        this.addForm = {
         id:id,
         userId:res.userId,  
         companyId:res.companyId,   
         agencyName:res.agencyName,
         email:res.email,
         companyName:res.companyName,
         loginAccount:res.loginAccount,
         firstName:res.firstName,
         mobileNumber:res.mobileNumber,
         lastName:res.lastName,
         postCode:res.postCode,
         address:res.address,
         areaList:res.areaList,
        }
        this.areaList=res.areaList
      })
    },

    enableEngineer(id,userId) {
     console.log("msg"+userId)
       this.$get(`engineer/updateEngineerStatus/${id}/${0}/${userId}`).then(({ data: res }) => {
          console.log("msg"+res.msg)
          if (res.msg !== 'successfully') {
            return this.$message.error('Enabled unsuccessfully')
          }
          // 刷新数据列表
          this.search()
          // 提示修改成功
          this.$message.success('Enabled successfully')
        })
    },
    suspendEngineer(id,userId) {
      console.log("msg"+userId)
       this.$get(`engineer/updateEngineerStatus/${id}/${1}/${userId}`).then(({ data: res }) => {
          
          if (res.msg !== 'successfully') {
            return this.$message.error('Disabled unsuccessfully')
          }
          // 刷新数据列表
          this.search()
          // 提示修改成功
          this.$message.success('Disabled successfully')
        })
    },

    editEngineerInfo() {
      this.addForm.areaList=this.areaList;
      this.$refs.editFormRef.validate(async (valid) => {
        debugger
        this.addForm.areaFullpath=this.areaList.join(',');
        this.addForm.areaList=null;
        if (!valid) return
        const loading = this.$loading({
          lock: true,
          text: 'Saving',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        this.$post('engineer/updateEngineer', this.addForm).then(({ data: res }) => {
          console.log(res)
          if (res.msg !== 'successfully') {
            loading.close()
            return this.$message.error('Update unsuccessfully')
          }
          loading.close()
          // 关闭对话框
          this.editDialogVisible = false
          // 刷新数据列表
          this.search()
          // 提示修改成功
          this.$message.success('Update successfully')
        })
      })
    },
     async reset() {
       this.queryInfoparams.params.agent='';
       this.queryInfoparams.params.company='';
       this.queryInfoparams.params.name='';
       this.queryInfoparams.params.phone='';
       this.queryInfoparams.params.email='';

    },
   }
  }

</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.collapseBtn {
  height: 40px;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

#el-collapse-head-4510{
  height: auto;
}
.el-col{
  display: flex;
}
.el-date-editor{
   height: auto;
   width:auto;
}
.demonstration1{
  height: auto;
  width:25%;
}
.el-button{
     height: auto;
     width:auto;
}
.left{
  width:auto;
}
#el-input__inner{
  width:200px;
}
/deep/#displayInput{
  display: none;
}
</style>